/*
  Vistavie — troca a imagem do card de coleção ao passar/focar numa cor.
  - Hover/foco numa bolinha => mostra a foto daquela cor (pré-visualização).
  - Sair da fileira de cores => volta para a imagem original.
  - Clique => navega para o produto já naquela cor (link nativo do <a>).
  Funciona com delegação de eventos, então cobre cards carregados por
  filtros/paginação assíncrona sem precisar reinicializar.
*/
(function () {
  'use strict';

  function primaryImage(card) {
    return card.querySelector('.card__media .media img');
  }

  function preview(swatch) {
    var wrap = swatch.closest('[data-vv-card-swatches]');
    var card = swatch.closest('.card');
    if (!wrap || !card) return;

    var src = swatch.getAttribute('data-media-src');
    if (!src) return;

    var img = primaryImage(card);
    if (!img) return;

    if (typeof img.dataset.vvOrigSrc === 'undefined') {
      img.dataset.vvOrigSrc = img.getAttribute('src') || '';
      img.dataset.vvOrigSrcset = img.getAttribute('srcset') || '';
    }

    var srcset = swatch.getAttribute('data-media-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
    } else {
      img.removeAttribute('srcset');
    }
    img.setAttribute('src', src);

    card.classList.add('is-swatch-preview');

    wrap.querySelectorAll('.vv-card-swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
  }

  function reset(wrap) {
    var card = wrap.closest('.card');
    if (!card) return;

    var img = primaryImage(card);
    if (img && typeof img.dataset.vvOrigSrc !== 'undefined') {
      if (img.dataset.vvOrigSrcset) {
        img.setAttribute('srcset', img.dataset.vvOrigSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      img.setAttribute('src', img.dataset.vvOrigSrc);
    }

    card.classList.remove('is-swatch-preview');
    wrap.querySelectorAll('.vv-card-swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
  }

  function closestSwatch(el) {
    return el && el.closest ? el.closest('.vv-card-swatch') : null;
  }

  // Pré-carrega as fotos das variantes assim que o cursor entra no card,
  // para que a troca de cor seja instantânea (sem esperar o download).
  function warm(el) {
    if (!el || !el.closest) return;
    var cardWrap = el.closest('.card-wrapper');
    if (!cardWrap) return;
    var wrap = cardWrap.querySelector('[data-vv-card-swatches]');
    if (!wrap || wrap.dataset.vvWarmed) return;
    wrap.dataset.vvWarmed = '1';
    wrap.querySelectorAll('.vv-card-swatch').forEach(function (s) {
      var src = s.getAttribute('data-media-src');
      if (!src) return;
      var img = new Image();
      var ss = s.getAttribute('data-media-srcset');
      if (ss) img.srcset = ss;
      img.src = src;
    });
  }

  document.addEventListener('mouseover', function (e) {
    warm(e.target);
    var sw = closestSwatch(e.target);
    if (sw) preview(sw);
  });

  document.addEventListener('focusin', function (e) {
    warm(e.target);
    var sw = closestSwatch(e.target);
    if (sw) preview(sw);
  });

  document.addEventListener('touchstart', function (e) {
    warm(e.target);
  }, { passive: true });

  document.addEventListener('mouseout', function (e) {
    var wrap = e.target.closest ? e.target.closest('[data-vv-card-swatches]') : null;
    if (!wrap) return;
    // Só reseta quando o ponteiro realmente sai da fileira de cores.
    if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;
    reset(wrap);
  });
})();
